import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../../api/axios';
import './LinkedInConversationReviews.css';

function LinkedInConversationReviews() {
  const { id } = useParams();
  const [items, setItems] = useState([]);
  const [busyId, setBusyId] = useState('');
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');

  const load = useCallback(async () => {
    try {
      const response = await api.get('/agent/linkedin/conversation-reviews');
      const filtered = (response.data.items || []).filter((item) =>
        (item.candidateMatches || []).some((candidate) => candidate.campaignId === id)
      );
      setItems(filtered);
      setError('');
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.response?.data?.error || requestError.message);
    }
  }, [id]);

  useEffect(() => { load(); }, [load]);

  const resolve = async (mappingId, candidate) => {
    setBusyId(mappingId); setError(''); setNotice('');
    try {
      await api.patch(`/agent/linkedin/conversation-reviews/${mappingId}/resolve`, {
        campaignId: candidate.campaignId,
        leadId: candidate.leadId,
      });
      setNotice('Gesprek is gekoppeld. De volgende inbox-sync start veilig vanaf een nieuwe cursor.');
      await load();
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.response?.data?.error || requestError.message);
    } finally { setBusyId(''); }
  };

  const dismiss = async (mappingId) => {
    setBusyId(mappingId); setError(''); setNotice('');
    try {
      await api.patch(`/agent/linkedin/conversation-reviews/${mappingId}/dismiss`, { reason: 'not_a_campaign_lead' });
      setNotice('Gesprek genegeerd.');
      await load();
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.response?.data?.error || requestError.message);
    } finally { setBusyId(''); }
  };

  return <main className="linkedin-review-page">
    <header className="linkedin-review-header">
      <div><Link to={`/campaigns/${id}/agent`}>← Terug naar AI-campagne</Link><p>LinkedIn review</p><h1>Ambigue gesprekken koppelen</h1><span>Kies alleen een lead wanneer de deelnemer duidelijk overeenkomt.</span></div>
      <button onClick={load}>Vernieuwen</button>
    </header>
    {notice && <div className="linkedin-review-notice">{notice}</div>}
    {error && <div className="linkedin-review-error">{error}</div>}
    {!items.length ? <section className="linkedin-review-empty">Geen ambigue LinkedIn-gesprekken voor deze campagne.</section> :
      <section className="linkedin-review-list">{items.map((item) => <article key={item._id}>
        <div className="linkedin-review-title"><div><strong>{item.participantName || 'Onbekende deelnemer'}</strong>{item.participantProfileUrl && <a href={item.participantProfileUrl} target="_blank" rel="noreferrer">Open profiel</a>}</div><span>{item.method || 'needs_review'}</span></div>
        <p>LinkedIn kon dit gesprek niet veilig aan één lead koppelen.</p>
        <div className="linkedin-review-candidates">{(item.candidateMatches || []).filter((candidate) => candidate.campaignId === id).map((candidate) => <div key={`${candidate.campaignId}-${candidate.leadId}`}>
          <div><strong>{candidate.leadName || candidate.leadId}</strong><span>{candidate.method} · {Math.round((candidate.confidence || 0) * 100)}%</span></div>
          <button disabled={busyId === item._id} onClick={() => resolve(item._id, candidate)}>Koppel aan deze lead</button>
        </div>)}</div>
        <button className="dismiss" disabled={busyId === item._id} onClick={() => dismiss(item._id)}>Niet relevant voor campagnes</button>
      </article>)}</section>}
  </main>;
}

export default LinkedInConversationReviews;
